<div class="p-3">
  <!-- Header Section -->
  <div class=" mb-4">
    <div class="card-body d-flex justify-content-between align-items-start">
      <div>
        <h4 class="card-title d-flex align-items-center mb-2">
          <i-tabler name="help-circle" class="me-2"></i-tabler>
          {{ 'QAInput.Title' | localize }}
        </h4>
        <p class="text-muted mb-0">{{ totalQuestionsText }}</p>
      </div>
      <div class="d-flex gap-3">
        <button
          mat-stroked-button
          color="accent"
          (click)="openImportModal()">
          <i-tabler name="download" class="me-1"></i-tabler>
          {{ 'QAInput.ImportButton' | localize }}
        </button>
      </div>
    </div>
  </div>

  <!-- QA Form Section -->
  <div class="">
    <div class="card-header">
      <h5 class="card-title d-flex align-items-center mb-0">
        <i-tabler name="plus" class="me-2"></i-tabler>
        {{ editingItem ? ('QAInput.EditQA' | localize) : ('QAInput.AddNewQA' | localize) }}
      </h5>
    </div>
    <div class="card-body">
      <form [formGroup]="qaForm" (ngSubmit)="saveQuestionAnswer()">
        <div class="mb-3">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{ 'QAInput.Question' | localize }}</mat-label>
            <textarea
              matInput
              formControlName="question"
              placeholder="{{ 'QAInput.QuestionPlaceholder' | localize }}"
              rows="3"
              maxlength="1000">
            </textarea>
            <mat-hint>{{ questionControl?.value?.length || 0 }}/1000</mat-hint>
            <mat-error *ngIf="questionControl?.invalid && questionControl?.touched">
              <span *ngIf="questionControl?.errors?.['required']">{{ 'QAInput.QuestionRequired' | localize }}</span>
              <span *ngIf="questionControl?.errors?.['minlength']">{{ 'QAInput.QuestionMinLength' | localize }}</span>
            </mat-error>
          </mat-form-field>
        </div>

        <div class="mb-3">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{ 'QAInput.Answer' | localize }}</mat-label>
            <textarea
              matInput
              formControlName="answer"
              placeholder="{{ 'QAInput.AnswerPlaceholder' | localize }}"
              rows="4"
              maxlength="2000">
            </textarea>
            <mat-hint>{{ answerControl?.value?.length || 0 }}/2000</mat-hint>
            <mat-error *ngIf="answerControl?.invalid && answerControl?.touched">
              <span *ngIf="answerControl?.errors?.['required']">{{ 'QAInput.AnswerRequired' | localize }}</span>
              <span *ngIf="answerControl?.errors?.['minlength']">{{ 'QAInput.AnswerMinLength' | localize }}</span>
            </mat-error>
          </mat-form-field>
        </div>

        <div class="mb-3">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{ 'QAInput.Tags' | localize }}</mat-label>
            <input
              matInput
              [(ngModel)]="tagInput"
              [ngModelOptions]="{standalone: true}"
              (keydown)="onTagKeyDown($event)"
              placeholder="{{ 'QAInput.TagsPlaceholder' | localize }}">
            <mat-hint>{{ 'QAInput.TagsHint' | localize }}</mat-hint>
          </mat-form-field>

          <!-- Tags Display -->
          <div class="mt-2" *ngIf="tags.length > 0">
            <div class="d-flex flex-wrap gap-2">
              <span
                *ngFor="let tag of tags; let i = index"
                class="badge bg-primary d-flex align-items-center gap-1">
                {{ tag }}
                <button
                  type="button"
                  class="btn-close btn-close-white btn-sm"
                  (click)="removeTag(i)"
                  style="font-size: 0.6rem;">
                </button>
              </span>
            </div>
          </div>
        </div>

        <div class="d-flex gap-2">
          <button
            type="button"
            class="btn btn-secondary"
            (click)="resetForm()">
            <i-tabler name="refresh" class="me-1"></i-tabler>
            {{ editingItem ? ('QAInput.Cancel' | localize) : ('QAInput.Clear' | localize) }}
          </button>
          <button
            type="submit"
            class="btn btn-primary"
            [disabled]="qaForm.invalid || loading">
            <mat-spinner *ngIf="loading" diameter="16" class="me-2"></mat-spinner>
            <i-tabler *ngIf="!loading" name="check" class="me-1"></i-tabler>
            {{ editingItem ? ('QAInput.Update' | localize) : ('QAInput.Save' | localize) }}
          </button>
        </div>
      </form>
    </div>
  </div>

  <!-- QA List Section -->
  <div class="mt-4" *ngIf="qaList.length > 0">
    <div class="card-header">
      <h5 class="card-title d-flex align-items-center mb-0">
        <i-tabler name="list" class="me-2"></i-tabler>
        {{ 'QAInput.AddedQAs' | localize }}
      </h5>
    </div>

    <!-- Search Bar -->
    <div class="card-body pb-2">
      <div class="row">
        <div class="col-12 mt-3">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{ 'QAInput.Search' | localize }}</mat-label>
            <input
              matInput
              [(ngModel)]="searchQuery"
              [ngModelOptions]="{standalone: true}"
              (input)="onSearchChange()"
              placeholder="{{ 'QAInput.SearchPlaceholder' | localize }}">
            <mat-icon matSuffix *ngIf="!searchQuery">search</mat-icon>
            <button
              *ngIf="searchQuery"
              matSuffix
              mat-icon-button
              (click)="clearSearch()"
              matTooltip="{{ 'QAInput.ClearSearch' | localize }}">
              <mat-icon>close</mat-icon>
            </button>
            <mat-hint *ngIf="searchQuery">{{ searchResultsText }}</mat-hint>
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="card-body p-0 mt-2" style="max-height: 500px; overflow-y: auto;">
      <!-- Arama Sonucu Bulunamadı -->
      <div *ngIf="filteredQaList.length === 0 && searchQuery" class="text-center py-4">
        <i-tabler name="search-off" class="display-4 text-muted mb-3"></i-tabler>
        <h6>{{ 'QAInput.NoSearchResults' | localize }}</h6>
        <p class="text-muted">
          {{ noResultsForText }}
          <button class="btn btn-link p-0" (click)="clearSearch()">{{ 'QAInput.ClearSearch' | localize }}</button>
        </p>
      </div>

      <!-- QA Listesi -->
      <div class="" *ngIf="filteredQaList.length > 0">
        <div
          *ngFor="let item of filteredQaList; let i = index; trackBy: trackByFn"
          class="border-bottom p-3"
          [class.opacity-50]="!item.isActive">

          <div class="d-flex justify-content-between align-items-start">
            <div class="flex-grow-1 me-3">
              <div class="d-flex justify-content-between align-items-start mb-2">
                <h6 class="mb-1 fw-bold">{{ item.question }}</h6>
                <mat-slide-toggle
                  [checked]="item.isActive"
                  (change)="toggleActive(item)"
                  color="primary"
                  class="ms-2">
                </mat-slide-toggle>
              </div>

              <p class="mb-2">{{ item.answer }}</p>

              <div *ngIf="item.tags && item.tags.length > 0" class="mb-2">
                <span
                  *ngFor="let tag of item.tags"
                  class="badge bg-secondary me-1">
                  {{ tag }}
                </span>
              </div>

              <small >
                {{ 'QAInput.Added' | localize }} {{ item.createdAt | date:'dd.MM.yyyy HH:mm' }}
              </small>
            </div>

            <div class="d-flex flex-column gap-1">
              <button
                type="button"
                class="btn btn-sm btn-outline-primary"
                (click)="editQuestionAnswer(item)"
                matTooltip="{{ 'QAInput.Edit' | localize }}">
                <i-tabler name="edit" class="me-1"></i-tabler>
                {{ 'QAInput.Edit' | localize }}
              </button>

              <button
                type="button"
                class="btn btn-sm btn-outline-danger"
                (click)="deleteQuestionAnswer(item)"
                matTooltip="{{ 'QAInput.Delete' | localize }}">
                <i-tabler name="trash" class="me-1"></i-tabler>
                {{ 'QAInput.Delete' | localize }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Liste Footer - Toplam Bilgisi -->
    <div class="card-footer bg-light text-center py-2" *ngIf="qaList.length > 5">
      <small class="text-muted">
        <i-tabler name="info-circle" class="me-1"></i-tabler>
        {{ qAsAvailableText }}
        <span *ngIf="!searchQuery">{{ 'QAInput.ScrollToView' | localize }}</span>
        <span *ngIf="searchQuery">{{ searchResultsCountText }}</span>
      </small>
    </div>
  </div>

  <!-- Empty State -->
  <div class="mt-4 text-center py-4" *ngIf="qaList.length === 0">
    <div class="card-body">
      <i-tabler name="help-circle" class="display-4 text-muted mb-3"></i-tabler>
      <h5>{{ 'QAInput.NoQAsYet' | localize }}</h5>
      <p class="">{{ 'QAInput.AddFirstQA' | localize }}</p>
    </div>
  </div>
</div>

<!-- Import Modal -->
<div class="modal fade show d-block" *ngIf="showImportModal" (click)="closeImportModal()">
  <div class="modal-dialog" (click)="$event.stopPropagation()">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title d-flex align-items-center">
          <i-tabler name="download" class="me-2"></i-tabler>
          {{ 'QAInput.ImportFromExcel' | localize }}
        </h5>
        <button
          type="button"
          class="btn-close"
          (click)="closeImportModal()">
        </button>
      </div>

      <div class="modal-body">
        <div class="alert alert-info d-flex align-items-start mb-4">
          <i-tabler name="info-circle" class="me-2 mt-1"></i-tabler>
          <div>
            <h6 class="alert-heading mb-2">{{ 'QAInput.FileFormat' | localize }}</h6>
            <p class="mb-2">{{ 'QAInput.FileFormatDescription' | localize }}</p>
            <div class="bg-light p-2 rounded border">
              <code>{{ 'QAInput.Question' | localize }}</code> | <code>{{ 'QAInput.Answer' | localize }}</code>
            </div>
          </div>
        </div>

        <input
          type="file"
          #fileInput
          (change)="onFileSelected($event)"
          accept=".xlsx,.xls,.csv"
          hidden>

        <div
          class="border border-2 border-dashed rounded p-4 text-center"
          [class.border-success]="uploadedFile"
          [class.bg-light]="!uploadedFile"
          [class.bg-success-subtle]="uploadedFile">
          <i-tabler
            [name]="uploadedFile ? 'file-check' : 'upload'"
            class="display-4"
            [class.text-muted]="!uploadedFile"
            [class.text-success]="uploadedFile">
          </i-tabler>

          <h6 class="mt-3" [class.text-success]="uploadedFile">
            {{ uploadedFile ? uploadedFile.name : ('QAInput.SelectFile' | localize) }}
          </h6>
          <p class="text-muted mb-3">{{ 'QAInput.FileDescription' | localize }}</p>

          <button
            type="button"
            class="btn btn-outline-primary"
            (click)="fileInput.click()">
            <i-tabler name="folder-open" class="me-1"></i-tabler>
            {{ uploadedFile ? ('QAInput.ChangeFile' | localize) : ('QAInput.ChooseFile' | localize) }}
          </button>
        </div>
      </div>

      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          (click)="closeImportModal()">
          {{ 'QAInput.Cancel' | localize }}
        </button>
        <button
          type="button"
          class="btn btn-success"
          (click)="importFromExcel()"
          [disabled]="!uploadedFile || importLoading">
          <mat-spinner *ngIf="importLoading" diameter="16" class="me-2"></mat-spinner>
          <i-tabler *ngIf="!importLoading" name="download" class="me-1"></i-tabler>
          {{ 'QAInput.Import' | localize }}
        </button>
      </div>
    </div>
  </div>
</div>
